import { render, staticRenderFns } from "./statistics-counting.vue?vue&type=template&id=3cb98f72"
import script from "./statistics-counting.vue?vue&type=script&lang=js"
export * from "./statistics-counting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports